import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
    Box,
    ListItemButton,
    ListItemText,
    Chip,
    Typography,
} from '@mui/material';
import { ArrowForward } from '@mui/icons-material';

export function MobileSubmenuItem({ subItem, subIndex, hasDivider, onClose, isItemRegistered }) {
    const plDepth = hasDivider ? 5 : 4;

    if (subItem.isDivider) {
        return (
            <Box key={`divider-${subIndex}`}>
                {subIndex > 0 && <Box sx={{ height: '1px', bgcolor: 'divider', my: 1, ml: 4, mr: 2 }} />}
                {subItem.path ? (
                    <ListItemButton
                        component={Link}
                        to={subItem.path}
                        onClick={onClose}
                        sx={{
                            pl: 4,
                            pr: 2,
                            py: 0.75,
                            minHeight: 'unset',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            '&:hover': {
                                bgcolor: 'action.hover',
                                '& .MuiTypography-root': {
                                    color: 'primary.dark',
                                },
                                '& .arrow-icon': {
                                    transform: 'translateX(2px)',
                                    color: 'primary.dark',
                                },
                            },
                        }}
                    >
                        <Typography
                            variant="overline"
                            sx={{
                                color: 'primary.main',
                                fontWeight: 700,
                                lineHeight: 1.2,
                                letterSpacing: '0.08em',
                            }}
                        >
                            {subItem.label}
                        </Typography>
                        <ArrowForward
                            className="arrow-icon"
                            sx={{
                                fontSize: '0.85rem',
                                color: 'primary.main',
                                transition: 'transform 0.15s ease-in-out',
                            }}
                        />
                    </ListItemButton>
                ) : (
                    <Box sx={{ pl: 4, pt: 1, pb: 0.5 }}>
                        <Typography variant="overline" sx={{ color: 'text.secondary', fontWeight: 'bold', lineHeight: 1 }}>
                            {subItem.label}
                        </Typography>
                    </Box>
                )}
            </Box>
        );
    }

    if (subItem.disabled || !subItem.path) {
        return (
            <ListItemButton
                key={subItem.label}
                disabled
                sx={{ pl: plDepth }}
            >
                <ListItemText
                    primary={subItem.label}
                    slotProps={{ primary: { color: 'text.secondary', fontStyle: 'italic', fontSize: '0.85rem' } }}
                />
            </ListItemButton>
        );
    }

    return (
        <ListItemButton
            key={subItem.label}
            component={Link}
            to={subItem.path}
            onClick={onClose}
            sx={{
                pl: plDepth,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
            }}
        >
            <ListItemText primary={subItem.label} />
            {isItemRegistered?.(subItem) && (
                <Chip
                    className="registered-chip"
                    label="Registered"
                    size="small"
                    color="success"
                    sx={{
                        height: 20,
                        fontSize: '0.68rem',
                        fontWeight: 700,
                        ml: 1,
                    }}
                />
            )}
        </ListItemButton>
    );
}

MobileSubmenuItem.propTypes = {
    subItem: PropTypes.object.isRequired,
    subIndex: PropTypes.number.isRequired,
    hasDivider: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    isItemRegistered: PropTypes.func,
};

export default MobileSubmenuItem;
